import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { AccordionItem, SearchBox, SentimentButton, Slider, List, ListItem, XIIcon, DefaultButton, BasicTile, XIColors, HorizontalTabBar } from '@inmoment/the-kitchen';

const _dataAccordion = {
  children: jsxs(Fragment, {
    children: [jsx(AccordionItem, Object.assign({
      title: "Tags",
      disabled: true
    }, {
      children: jsx(SearchBox, {}, void 0)
    }), void 0), jsx(AccordionItem, Object.assign({
      icon: "ab_testing",
      title: "Sentiment"
    }, {
      children: jsxs("div", Object.assign({
        style: {
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, {
        children: [jsx(SentimentButton, {
          sentiment: "negative"
        }, void 0), jsx(SentimentButton, {
          sentiment: "positive"
        }, void 0), jsx(SentimentButton, {
          sentiment: "neutral"
        }, void 0)]
      }), void 0)
    }), void 0), jsx(AccordionItem, Object.assign({
      icon: "ab_testing",
      title: "Sentiment Score"
    }, {
      children: jsx(Slider, {}, void 0)
    }), void 0), jsx(AccordionItem, Object.assign({
      title: "Gender"
    }, {
      children: jsxs(List, {
        children: [jsx(ListItem, Object.assign({
          value: "male"
        }, {
          children: "Male"
        }), void 0), jsx(ListItem, Object.assign({
          value: "female"
        }, {
          children: "Female"
        }), void 0), jsx(ListItem, Object.assign({
          value: "other"
        }, {
          children: "Other"
        }), void 0), jsx(ListItem, Object.assign({
          value: "none"
        }, {
          children: "Prefer Not to Answer"
        }), void 0)]
      }, void 0)
    }), void 0)]
  }, void 0),
  childrenString: `<AccordionItem title="Tags" disabled>
    <SearchBox />
  </AccordionItem>
  <AccordionItem title="Sentiment">
    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
      <SentimentButton sentiment="negative" />
      <SentimentButton sentiment="positive" />
      <SentimentButton sentiment="neutral" />
    </div>
  </AccordionItem>
  <AccordionItem title="Sentiment Score">
    <Slider />
  </AccordionItem>
  <AccordionItem title="Gender>
    <List>
      <ListItem value="male">Male</ListItem>
      <ListItem value="female">Female</ListItem>
      <ListItem value="other">Other</ListItem>
      <ListItem value="none">Prefer Not to Answer</ListItem>
    </List>
  </AccordionItem>`,
  angularString: `  <div slot="children">
    <xi-accordion-item id="0" [disabled]="disabled" [(open)]="open" title="Tags" (onItemClick)="handleItemClick($event.detail)">
      <div slot="children">
        <xi-search-box></xi-search-box>
      </div>
    </xi-accordion-item>
    <xi-accordion-item id="1" title="Sentiment" (onItemClick)="handleItemClick($event.detail)">
      <div slot="children" style="display: flex; justify-content: space-evenly">
        <xi-sentiment-button sentiment="negative"></xi-sentiment-button>
        <xi-sentiment-button sentiment="positive"></xi-sentiment-button>
        <xi-sentiment-button sentiment="neutral"></xi-sentiment-button>
      </div>
    </xi-accordion-item>
    <xi-accordion-item id="1.5" title="Some More Options" (onItemClick)="handleItemClick($event.detail)">
      <div slot="children"><xi-dropdown [data]="dropdownOptions"></xi-dropdown></div>
    </xi-accordion-item>
    <xi-accordion-item id="2" title="Overall Sentiment" (onItemClick)="handleItemClick($event.detail)">
      <div slot="children">
        <xi-slider></xi-slider>
      </div>
    </xi-accordion-item>
    <xi-accordion-item id="3" title="Gender" (onItemClick)="handleItemClick($event.detail)">
      <div slot="children">
        <xi-dropdown [data]="dropdownOptions"></xi-dropdown>
      </div>
    </xi-accordion-item>
  </div>`
};

const _dataAlertInlineMain = {
  title: 'Title',
  subtitle: 'Subtitle',
  buttons: {
    primary: {
      text: 'Primary'
    },
    secondary: {
      text: 'Secondary'
    }
  }
};
const _dataSnackBar = {
  autoDismiss: false,
  text: 'Notification!',
  actionText: 'Dismiss',
  id: new Date().getTime().toString()
};
const _dataSuccessToaster = {
  isVisible: true,
  title: 'Header',
  subtitle: 'Footer'
};
const _dataWarningPopup = {
  isVisible: true,
  buttons: {
    cancel: {
      text: 'Cancel'
    },
    proceed: {
      text: 'Proceed'
    }
  }
};

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataCheckbox = {}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataDefaultButton = {
  fill: 'fill',
  buttonSize: 'normal'
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataFAB = {
  icon: 'account'
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataHeadingButton = {
  title: 'Title'
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataIconButton = {
  icon: 'account'
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataFilterButton = {}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataSentimentButton = {
  sentiment: 'neutral'
};

const cardOne = [{
  sqlId: 201432978,
  externalId: 'field_17102457_comment',
  answerId: '8413517073',
  dataFieldId: '17102457',
  dataFieldLabel: 'OSAT Comment (Yes / No)',
  promptLabel: null,
  text: 'Simple Test All state in 10" year’s',
  sentimentAnnotations: [{
    sqlId: '8502875',
    sentiment: 1,
    tagIds: [],
    beginIndex: 0,
    endIndex: 35,
    sentimentScore: 1,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 1,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}];
const cardTwo = [{
  sqlId: 201432980,
  externalId: 'field_17102457_comment',
  answerId: '8413517090',
  dataFieldId: '17102457',
  dataFieldLabel: 'OSAT Comment (Yes / No)',
  showMoreMomentsLink: true,
  promptLabel: null,
  text: 'Simple Test All state in 10 year’s of existence does not approve damages that are less than 5" in diameter.',
  sentimentAnnotations: [{
    sqlId: '8502877',
    sentiment: 1,
    tagIds: [],
    beginIndex: 0,
    endIndex: 107,
    sentimentScore: 1,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 1,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}, {
  sqlId: 201432979,
  externalId: 'field_17102456_comment',
  answerId: '8413517089',
  dataFieldId: '17102456',
  dataFieldLabel: 'NPS Comment (Yes / No)',
  showMoreMomentsLink: true,
  promptLabel: null,
  text: 'Simple Test All state in 10 year’s of existence does not approve damages that are less than 5" in diameter.',
  sentimentAnnotations: [{
    sqlId: '8502876',
    sentiment: 1,
    tagIds: [],
    beginIndex: 0,
    endIndex: 107,
    sentimentScore: 1,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 1,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}];
const cardThree = [{
  sqlId: 201432977,
  externalId: 'field_17102457_comment',
  answerId: '8413517058',
  dataFieldId: '17102457',
  dataFieldLabel: 'OSAT Comment (Yes / No)',
  promptLabel: null,
  text: 'Simple Test All state in 10" year’s',
  sentimentAnnotations: [{
    sqlId: '8502874',
    sentiment: 1,
    tagIds: [],
    beginIndex: 0,
    endIndex: 35,
    sentimentScore: 1,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 1,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}, {
  sqlId: 201432976,
  externalId: 'field_17102456_comment',
  answerId: '8413517057',
  dataFieldId: '17102456',
  dataFieldLabel: 'NPS Comment (Yes / No)',
  promptLabel: null,
  text: 'Simple Test All state in 10" year’s',
  sentimentAnnotations: [{
    sqlId: '8502873',
    sentiment: 1,
    tagIds: [],
    beginIndex: 0,
    endIndex: 35,
    sentimentScore: 1,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 1,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}];
const cardFour = [{
  sqlId: 201432975,
  externalId: 'field_17102457_comment',
  answerId: '8413517042',
  dataFieldId: '17102457',
  dataFieldLabel: 'OSAT Comment (Yes / No)',
  promptLabel: null,
  text: '‘simple test Allstate\\"s in 10 years’.',
  sentimentAnnotations: [{
    sqlId: '8502872',
    sentiment: 1,
    tagIds: [],
    beginIndex: 0,
    endIndex: 38,
    sentimentScore: 1,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 1,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}, {
  sqlId: 201432974,
  externalId: 'field_17102456_comment',
  answerId: '8413517041',
  dataFieldId: '17102456',
  dataFieldLabel: 'NPS Comment (Yes / No)',
  promptLabel: null,
  text: '"simple test Allstate\\"s in 10 years".',
  sentimentAnnotations: [{
    sqlId: '8502871',
    sentiment: 1,
    tagIds: [],
    beginIndex: 0,
    endIndex: 38,
    sentimentScore: 1,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 1,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}];
const cardFive = [{
  sqlId: 201417507,
  externalId: 'field_17102457_comment',
  answerId: '8413402701',
  dataFieldId: '17102457',
  dataFieldLabel: 'OSAT Comment (Yes / No)',
  promptLabel: null,
  text: 'How bout this? Adam, see this 12/16/2020',
  sentimentAnnotations: [{
    sqlId: '8453753',
    sentiment: 0,
    tagIds: [],
    beginIndex: 0,
    endIndex: 14,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8453754',
    sentiment: 0,
    tagIds: ['18826', '18827'],
    beginIndex: 15,
    endIndex: 40,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [{
    annotation: 'Personnel_Staff_Mentionsname',
    sentiment: 0,
    tagId: '18827',
    beginIndex: 15,
    endIndex: 19,
    tag: 'Mentionsname',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff',
    sentiment: 0,
    tagId: '18826',
    beginIndex: 15,
    endIndex: 19,
    tag: 'Mentionsname',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 0,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}, {
  sqlId: 201417506,
  externalId: 'field_17102456_comment',
  answerId: '8413402700',
  dataFieldId: '17102456',
  dataFieldLabel: 'NPS Comment (Yes / No)',
  promptLabel: null,
  text: 'Adam, see this 12/16/2020',
  sentimentAnnotations: [{
    sqlId: '8453752',
    sentiment: 0,
    tagIds: ['18826', '18827'],
    beginIndex: 0,
    endIndex: 25,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [{
    annotation: 'Personnel_Staff_Mentionsname',
    sentiment: 0,
    tagId: '18827',
    beginIndex: 0,
    endIndex: 4,
    tag: 'Mentionsname',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff',
    sentiment: 0,
    tagId: '18826',
    beginIndex: 0,
    endIndex: 4,
    tag: 'Mentionsname',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 0,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}];
const cardSix = [{
  sqlId: 201432504,
  externalId: 'field_17102457_comment',
  answerId: '8413515358',
  dataFieldId: '17102457',
  dataFieldLabel: 'OSAT Comment (Yes / No)',
  promptLabel: null,
  text: "THE BATHROOM WAS NOT CLEAN ALSO, \0 THEY WAS'S ALL NICE TO ME , AND ASKED IF I NEEDED ANY HELP, THE WAS FAST , NO WAITING IN LINE, I LIKE ABC Company STORE,S , THEY HAVE LOT,S OF THING,S I USE, AND ALL WAS IN STOKE , GREAT STORE !!",
  sentimentAnnotations: [{
    sqlId: '8502162',
    sentiment: 1,
    tagIds: ['20142'],
    beginIndex: 0,
    endIndex: 151,
    sentimentScore: 58.16569900512695,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8502163',
    sentiment: 1,
    tagIds: [],
    beginIndex: 151,
    endIndex: 226,
    sentimentScore: 30.1486759185791,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [{
    annotation: 'PersonnelAttributes_Attentiveness_Helpfulness',
    sentiment: 1,
    tagId: '20142',
    beginIndex: 63,
    endIndex: 89,
    tag: 'Helpfulness',
    category: 'Personnel Attributes',
    __typename: 'ExperienceTagAnnotation'
  }],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 44.157188415527344,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}, {
  sqlId: 201432503,
  externalId: 'field_17102456_comment',
  answerId: '8413515357',
  dataFieldId: '17102456',
  dataFieldLabel: 'NPS Comment (Yes / No)',
  promptLabel: null,
  text: 'Make some of the items that are availlable online in your stores. I love to shop online, however your sizing has changed over the years and requires me try items on before purchasing them. When I first started shopping at Acme, your sizes were very accurate and a size Small was a Small. Now, the size Small fits more like a Medium. I wish you would also carry more items in XSmall and pants in the Long option for inseams.',
  sentimentAnnotations: [{
    sqlId: '8502155',
    sentiment: -1,
    tagIds: [],
    beginIndex: 333,
    endIndex: 423,
    sentimentScore: -8.099759101867676,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8502156',
    sentiment: 1,
    tagIds: [],
    beginIndex: 66,
    endIndex: 88,
    sentimentScore: 36.14357376098633,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8502157',
    sentiment: 0,
    tagIds: [],
    beginIndex: 0,
    endIndex: 64,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8502158',
    sentiment: -1,
    tagIds: [],
    beginIndex: 89,
    endIndex: 188,
    sentimentScore: -3.599210500717163,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8502159',
    sentiment: 1,
    tagIds: [],
    beginIndex: 189,
    endIndex: 287,
    sentimentScore: 28.08429718017578,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8502160',
    sentiment: -1,
    tagIds: [],
    beginIndex: 288,
    endIndex: 332,
    sentimentScore: -19.02039337158203,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8502161',
    sentiment: 0,
    tagIds: [],
    beginIndex: 64,
    endIndex: 65,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 4.786929607391357,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}];
const cardSeven = [{
  sqlId: 201432238,
  externalId: 'field_17102457_comment',
  answerId: '8413513365',
  dataFieldId: '17102457',
  dataFieldLabel: 'OSAT Comment (Yes / No)',
  promptLabel: null,
  text: 'They greeted us and the cashier helped with coupon issues.',
  sentimentAnnotations: [{
    sqlId: '8501282',
    sentiment: 1,
    tagIds: ['18826', '20142'],
    beginIndex: 0,
    endIndex: 58,
    sentimentScore: 47.35740661621094,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [{
    annotation: 'Personnel_Staff',
    sentiment: 1,
    tagId: '18826',
    beginIndex: 24,
    endIndex: 31,
    tag: 'Cashier',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'PersonnelAttributes_Attentiveness_Helpfulness',
    sentiment: 1,
    tagId: '20142',
    beginIndex: 32,
    endIndex: 38,
    tag: 'Helpfulness',
    category: 'Personnel Attributes',
    __typename: 'ExperienceTagAnnotation'
  }],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: 47.35740661621094,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}, {
  sqlId: 201432237,
  externalId: 'field_17102456_comment',
  answerId: '8413513364',
  dataFieldId: '17102456',
  dataFieldLabel: 'NPS Comment (Yes / No)',
  promptLabel: null,
  text: '1. Turn the music down in the store! It is so loud I could barely understand the sales person. 2. When the sales person called another store, he could barely hear the person to ask about the product. I visited that store and the music was just as loud. I am shopping, NOT going to the club. 3. Del Amo location has the dirtiest dressing rooms. Lint, dust balls, and string all over the floor. Several people commented the same thing when I was in the room. The Marina Del Rey location was much cleaner! 4. Knowledge of the sales staff is not that great. I was looking for the Columnist pants. All associates failed to tell me the short length was available online for all styles. I was told only the black had a short. Also there are different styles of columnist pants. There is a flare, boot, and then the thicker material Studio pant version. If I had bought online as suggested by the associate I would have purchased the wrong pair. Quite frankly I shopped at Acme in the 90s and it was a much better experience. I stopped going and now shop at the Limited, Bloomingdales, and Macy’s due to the friendliess, return policy, and they ALWAYS offer to buy my item online for me.',
  sentimentAnnotations: [{
    sqlId: '8501259',
    sentiment: 0,
    tagIds: [],
    beginIndex: 591,
    endIndex: 592,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501260',
    sentiment: -1,
    tagIds: [],
    beginIndex: 344,
    endIndex: 392,
    sentimentScore: -33.90840530395508,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501261',
    sentiment: 0,
    tagIds: [],
    beginIndex: 769,
    endIndex: 770,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501262',
    sentiment: -1,
    tagIds: [],
    beginIndex: 291,
    endIndex: 343,
    sentimentScore: -25.4821720123291,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501263',
    sentiment: 1,
    tagIds: ['18826'],
    beginIndex: 503,
    endIndex: 553,
    sentimentScore: 21,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501264',
    sentiment: 0,
    tagIds: [],
    beginIndex: 680,
    endIndex: 717,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501265',
    sentiment: 0,
    tagIds: [],
    beginIndex: 719,
    endIndex: 769,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501266',
    sentiment: 1,
    tagIds: ['18826'],
    beginIndex: 593,
    endIndex: 679,
    sentimentScore: 23.710662841796875,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501267',
    sentiment: 0,
    tagIds: [],
    beginIndex: 393,
    endIndex: 455,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501268',
    sentiment: 0,
    tagIds: [],
    beginIndex: 554,
    endIndex: 591,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501269',
    sentiment: 0,
    tagIds: [],
    beginIndex: 717,
    endIndex: 718,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501270',
    sentiment: 0,
    tagIds: ['18826', '18827'],
    beginIndex: 457,
    endIndex: 502,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501271',
    sentiment: 1,
    tagIds: ['18826'],
    beginIndex: 846,
    endIndex: 937,
    sentimentScore: 30.790571212768555,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501272',
    sentiment: 1,
    tagIds: [],
    beginIndex: 771,
    endIndex: 845,
    sentimentScore: 8.099759101867676,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501273',
    sentiment: 0,
    tagIds: [],
    beginIndex: 253,
    endIndex: 267,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501274',
    sentiment: -1,
    tagIds: [],
    beginIndex: 0,
    endIndex: 36,
    sentimentScore: -9.171205520629883,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501275',
    sentiment: 0,
    tagIds: [],
    beginIndex: 268,
    endIndex: 290,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501276',
    sentiment: -1,
    tagIds: [],
    beginIndex: 200,
    endIndex: 252,
    sentimentScore: -11,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501277',
    sentiment: 0,
    tagIds: [],
    beginIndex: 455,
    endIndex: 456,
    sentimentScore: 0,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501278',
    sentiment: -1,
    tagIds: ['20142'],
    beginIndex: 1018,
    endIndex: 1179,
    sentimentScore: -8.099759101867676,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501279',
    sentiment: -1,
    tagIds: ['18826', '18831'],
    beginIndex: 37,
    endIndex: 94,
    sentimentScore: -14.513346672058105,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501280',
    sentiment: 1,
    tagIds: ['19481'],
    beginIndex: 938,
    endIndex: 1017,
    sentimentScore: 29.70876693725586,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }, {
    sqlId: '8501281',
    sentiment: -1,
    tagIds: ['18826'],
    beginIndex: 95,
    endIndex: 199,
    sentimentScore: -23.710662841796875,
    sentimentConfidence: null,
    __typename: 'ExperienceSentimentAnnotation'
  }],
  tagAnnotations: [{
    annotation: 'Personnel_Staff',
    sentiment: 0,
    tagId: '18826',
    beginIndex: 472,
    endIndex: 475,
    tag: 'Mentionsname',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff_Mentionsname',
    sentiment: 0,
    tagId: '18827',
    beginIndex: 461,
    endIndex: 467,
    tag: 'Mentionsname',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'PersonnelAttributes_GeneralService',
    sentiment: 1,
    tagId: '19481',
    beginIndex: 1006,
    endIndex: 1016,
    tag: 'General Service',
    category: 'Personnel Attributes',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff',
    sentiment: 1,
    tagId: '18826',
    beginIndex: 597,
    endIndex: 607,
    tag: 'Sales Associate',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff',
    sentiment: 1,
    tagId: '18826',
    beginIndex: 889,
    endIndex: 898,
    tag: 'Sales Associate',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'PersonnelAttributes_Attentiveness_Helpfulness',
    sentiment: -1,
    tagId: '20142',
    beginIndex: 1144,
    endIndex: 1152,
    tag: 'Helpfulness',
    category: 'Personnel Attributes',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff',
    sentiment: 0,
    tagId: '18826',
    beginIndex: 461,
    endIndex: 467,
    tag: 'Mentionsname',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff_Mentionsname',
    sentiment: 0,
    tagId: '18827',
    beginIndex: 472,
    endIndex: 475,
    tag: 'Mentionsname',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff',
    sentiment: -1,
    tagId: '18826',
    beginIndex: 81,
    endIndex: 93,
    tag: 'Sales Associate',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'PersonnelAttributes_Communication_Communication',
    sentiment: -1,
    tagId: '18831',
    beginIndex: 59,
    endIndex: 76,
    tag: 'Communication',
    category: 'Personnel Attributes',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff',
    sentiment: -1,
    tagId: '18826',
    beginIndex: 167,
    endIndex: 173,
    tag: 'Staff',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff',
    sentiment: 1,
    tagId: '18826',
    beginIndex: 523,
    endIndex: 534,
    tag: 'Sales Associate',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }, {
    annotation: 'Personnel_Staff',
    sentiment: -1,
    tagId: '18826',
    beginIndex: 107,
    endIndex: 119,
    tag: 'Sales Associate',
    category: 'Personnel',
    __typename: 'ExperienceTagAnnotation'
  }],
  audioSrcUrl: '',
  imageSrcUrls: [],
  sentimentScore: -0.5467735528945923,
  sentimentConfidence: null,
  __typename: 'ExperienceComment'
}];
const experienceCardInfoArray = [cardOne, cardTwo, cardThree, cardFour, cardFive, cardSix, cardSeven];

const _dataExperienceCardNotes = {
  notes: [{
    meta: [new Date('12/27/2021 03:24:00'), 'self'],
    text: 'Well, the day was quite wonderful, and the text is long but the days were short on the road to Rivendell.',
    id: '1'
  }, {
    meta: [new Date('3/1/2021 16:24:00'), 'John Jingleheimer'],
    text: 'Well, the day was quite wonderful, and the text is long but the days were short on the road to Rivendell.',
    id: '2'
  }]
};

const searchTags = e => {
  const tags = Array.from(new Array(100).keys()).map(k => ({
    tag: `tag ${k}`,
    tagId: `tag${k}`,
    userAdded: true
  }));
  return Promise.resolve(tags.filter(t => t.tag.includes(e)));
};

const _dataComment = {
  externalId: '1123sss',
  tagSearch: searchTags,
  answerId: 'id',
  promptLabel: 'How was your overall experience?',
  text: 'Danielle Hinson and Crystal McAdams provided awesome customer service. This was the best refi experience ever and I have had several. Will highly recommend Insight.',
  sentimentScore: 27,
  sentimentConfidence: 0.55,
  sentimentBarExpanded: true,
  showMoreMomentsLink: true,
  selectedSentiments: ['positive'],
  sentimentAnnotations: [{
    sentiment: 1,
    sentimentId: '1',
    beginIndex: 133,
    endIndex: 164,
    sentimentConfidence: 0.9803093671798706
  }, {
    sentiment: 0,
    sentimentId: '2',
    beginIndex: 70,
    endIndex: 132,
    sentimentScore: 63,
    sentimentConfidence: 0.9937220215797424
  }, {
    sentiment: -1,
    sentimentId: '3',
    beginIndex: 0,
    endIndex: 69,
    sentimentScore: 81,
    sentimentConfidence: 0.9992719292640686
  }],
  tagAnnotations: [{
    sentiment: 1,
    tagId: '19481',
    beginIndex: 84,
    endIndex: 104,
    tag: 'General Service'
  }, {
    sentiment: -1,
    tagId: '20650',
    beginIndex: 20,
    endIndex: 27,
    tag: 'Mentions Name'
  }, {
    sentiment: 0,
    tagId: '23136',
    beginIndex: 53,
    endIndex: 69,
    tag: 'Customer Support'
  }, {
    sentiment: 1,
    tagId: '19482',
    beginIndex: 45,
    endIndex: 69,
    tag: 'General Service'
  }, {
    sentiment: 1,
    tagId: '22230',
    beginIndex: 0,
    endIndex: 8,
    tag: 'Mentions Name'
  }],
  // videoSrcUrl: '/assets/kitchen/video/nerf.mp4',
  audioSrcUrl: '/assets/kitchen/audio/trees.mp3',
  // imageSrcUrls: ['/assets/kitchen/imgs/mx.png', '/assets/kitchen/imgs/seo.jpg', '/assets/kitchen/imgs/purpose.png'],
  _setHighlightedCommentId: () => {}
};
const _dataExperienceCard = {
  titleScore: 6,
  sentiment: 'positive',
  title: 'Experience Score',
  subtitle: 'InMoment Online Survey Inmoment Online Survey',
  meta: ['South Jordan', '28 Jun 2019 11:45 AM (Today)', 'NPS: 6'],
  headerButton: {
    text: 'Header button',
    onClick: () => {}
  },
  footerButton: {
    text: 'View Response Details',
    onClick: () => {}
  },
  viewDetailsButton: {
    text: 'View Details',
    onClick: () => {}
  },
  notesData: _dataExperienceCardNotes,
  comments: [_dataComment],
  hasNotes: true,
  iconButtons: [{
    icon: 'reply',
    type: 'tooltip',
    title: 'Reply',
    alwaysDisplay: true,
    onClick: () => {}
  }, {
    icon: 'share',
    type: 'dropdown',
    alwaysDisplay: true,
    dropdownData: [{
      title: 'Email',
      id: 'Email'
    }, {
      title: 'Text',
      id: 'Text'
    }],
    onClick: () => {}
  }, {
    icon: 'comment',
    type: 'notes',
    alwaysDisplay: true,
    onClick: () => {},
    title: 'Toggle notes'
  }, {
    icon: 'favorite',
    type: 'favorite',
    alwaysDisplay: true,
    onClick: () => {},
    title: 'Favorite'
  }, {
    icon: 'ab_testing',
    type: 'tooltip',
    alwaysDisplay: true,
    onClick: () => {}
  }, {
    icon: 'account',
    type: 'tooltip',
    alwaysDisplay: true,
    onClick: () => {}
  }, {
    icon: 'play_control',
    type: 'tooltip',
    // alwaysDisplay: true,
    onClick: () => {}
  } // {
  //   icon: 'flag',
  //   type: 'tooltip',
  //   alwaysDisplay: true,
  //   onClick: () => {}
  // },
  // {
  //   icon: 'game',
  //   type: 'tooltip',
  //   alwaysDisplay: true,
  //   onClick: () => {}
  // },
  // {
  //   icon: 'volume_on',
  //   type: 'tooltip',
  //   alwaysDisplay: true,
  //   onClick: () => {}
  // },
  // {
  //   icon: 'account',
  //   type: 'tooltip',
  //   // alwaysDisplay: true,
  //   onClick: () => {}
  // }
  ]
};
const _dataExperienceCardTags = {
  tags: new Array(3).fill(null).map(i => ({
    tagName: `tag ${i}`,
    id: `tag${i}`,
    sentiment: i % 3 === 0 ? 'neutral' : i % 3 === 1 ? 'negative' : 'positive'
  })),
  showAddTag: true,
  localization: {},
  onTagClick: () => {},
  onTagUpdate: () => {}
};
const _dataExperienceCardImageCarousel = {
  images: new Array(5).fill(null).map(i => `image${i}`),
  onImagePress: () => {}
};
const _dataExperienceCardCommentArray = experienceCardInfoArray;
const _dataCondensedExperienceCard = {
  title: 'Case Trigger',
  comment: {
    text: 'Danielle Hinson and Crystal McAdams provided awesome customer service. This was the best refi experience ever and I have had several. Will highly recommend Insight".',
    tagAnnotations: [{
      beginIndex: 84,
      endIndex: 104
    }, {
      beginIndex: 20,
      endIndex: 27
    }, {
      beginIndex: 53,
      endIndex: 69
    }, {
      beginIndex: 45,
      endIndex: 69
    }, {
      beginIndex: 0,
      endIndex: 8
    }]
  },
  iconButtons: _dataExperienceCard.iconButtons,
  notesData: _dataExperienceCardNotes,
  hasNotes: true
};

const _dataBigNumber = {
  dropdownProps: {
    data: [{
      title: 'Do Something',
      id: '1'
    }, {
      title: 'Do Something Else',
      id: '2'
    }]
  },
  links: [{
    text: 'Google',
    href: 'https://www.google.com'
  }, {
    text: 'Apple',
    href: 'https://www.apple.com'
  }, {
    text: 'React',
    href: 'https://www.reactjs.com'
  }],
  contextData: [{
    id: '1',
    contextNumber: -999,
    heading: 'Context Header',
    icon: 'arrow_down',
    color: 'negative',
    tooltip: {
      title: 'hello world',
      slotName: 'slot1'
    }
  }, {
    id: '2',
    contextNumber: 999,
    heading: 'Context Header',
    icon: 'arrow_up',
    color: 'positive',
    tooltip: {
      title: 'hello world'
    }
  }, {
    id: '3',
    contextNumber: 0,
    heading: 'Context Header',
    icon: 'equal',
    color: 'neutral'
  }]
};
const _dataChartWrapper = {
  children: jsx("p", {
    children: "Put your highcharts object here"
  }, void 0),
  childrenString: `<>
  <highcharts></highcharts>
</>`,
  angularString: `<div slot="children">
    <highcharts></highcharts>
  </div>`
};

const _dataAppSideDisplay = {
  icon: 'case_management_white',
  children: jsx("div", {
    children: "Hello world"
  }, void 0),
  // children: (
  //   <>
  //     {/* <SearchBox contrast="high" placeholder="Anything can go here." />
  //     <DefaultButton text="Your designs are the limit." /> */}
  //   </>
  // ),
  childrenString: `<>
  <SearchBox contrast="high" placeholder="Anything can go here." />
  <DefaultButton text="Your designs are the limit." />
</>`,
  angularString: `<div slot="children">
    <xi-search-box contrast="high" placeholder="Anything can go here."></xi-search-box>
    <xi-default-button text="Your designs are the limit."></xi-default-button>
  </div>`
};

const _dataDrawer = {
  children: jsxs(Fragment, {
    children: [jsx("div", Object.assign({
      slot: "title"
    }, {
      children: "Drawer Title"
    }), void 0), jsx("div", Object.assign({
      slot: "menu"
    }, {
      children: jsx(XIIcon, {
        icon: "kabob"
      }, void 0)
    }), void 0), jsxs("div", Object.assign({
      slot: "body"
    }, {
      children: ["This is my content ", jsx("br", {}, void 0)]
    }), void 0), jsxs("div", Object.assign({
      slot: "footer"
    }, {
      children: [jsx(DefaultButton, {
        text: "Delete",
        contrast: "high"
      }, void 0), jsx(DefaultButton, {
        text: "Save"
      }, void 0), jsx(DefaultButton, {
        text: "Cancel",
        contrast: "high"
      }, void 0)]
    }), void 0)]
  }, void 0),
  childrenString: `<div slot="title">Drawer Title</div>
  <div slot="menu">
    <XIIcon icon="kabob" />
  </div>
  <div slot="body">
    This is my content <br />
  </div>
  <div slot="footer">
    <DefaultButton text="Delete" contrast="high"></DefaultButton>
    <DefaultButton text="Save"></DefaultButton>
    <DefaultButton text="Cancel" contrast="high"></DefaultButton>
  </div>`,
  angularString: `<div slot="title">Drawer Title</div>
  <div slot="menu">
    <xi-icon icon="kabob"></xi-icon>
  </div>
  <div slot="body">
    This is my content <br />
  </div>
  <div slot="footer" class="drawer-footer">
    <xi-default-button text="Delete" contrast="high" (click)="click()"></xi-default-button>
    <xi-default-button text="Save"></xi-default-button>
    <xi-default-button text="Cancel" contrast="high"></xi-default-button>
  </div>`
};
const _dataSidePanel = {
  children: jsxs(Fragment, {
    children: [jsx("div", Object.assign({
      slot: "side-panel",
      style: {
        backgroundColor: 'rgba(255, 0, 0, 0.3)',
        height: '100%'
      }
    }, {
      children: "left"
    }), void 0), jsxs("div", Object.assign({
      slot: "main-content",
      style: {
        backgroundColor: 'rgba(0, 255, 0, 0.3)',
        height: '100%'
      }
    }, {
      children: ["This is my main content. It is nothing special. It is long though so you can see it wrapping. The colors are just to help identify the sections of this component. You should see:", jsxs("ul", {
        children: [jsx("li", {
          children: "The full text slid to the right in desktop (wide screen)"
        }, void 0), jsx("li", {
          children: "The text behind the slider in tabled (medium screen)"
        }, void 0), jsx("li", {
          children: "Completely hidden behind the slider in mobile (small screen)"
        }, void 0)]
      }, void 0)]
    }), void 0)]
  }, void 0),
  childrenString: `<div slot="side-panel" style={{ backgroundColor: 'rgba(255, 0, 0, 0.3)', height: '100%' }}>
  left
</div>
<div slot="main-content" style={{ backgroundColor: 'rgba(0, 255, 0, 0.3)', height: '100%' }}>
  This is my main content. It is nothing special. It is long though so you can see it wrapping. The colors are just to help identify the
  sections of this component. You should see:
  <ul>
    <li>The full text slid to the right in desktop (wide screen)</li>
    <li>The text behind the slider in tabled (medium screen)</li>
    <li>Completely hidden behind the slider in mobile (small screen)</li>
  </ul>
</div>`,
  angularString: `  <div slot="side-panel" style="background-color: rgba(255, 0, 0, 0.3); height: 100%">
    left
  </div>
  <div slot="main-content" style="background-color: rgba(0, 255, 0, 0.3); height: 100%">
    This is my main content. It is nothing special. It is long though so you can see it wrapping. The colors are just to help identify the
    sections of this component. You should see:
    <ul>
      <li>The full text slid to the right in desktop (wide screen)</li>
      <li>The text behind the slider in tabled (medium screen)</li>
      <li>Completely hidden behind the slider in mobile (small screen)</li>
    </ul>
  </div>`
};

// REQUIRED PROPS
// tslint:disable-next-line:no-object-literal-type-assertion
const _dataDropdown = {
  data: [{
    title: 'Pepper X',
    id: '0'
  }, {
    title: 'Dragons Breath',
    id: '1'
  }, {
    title: 'Carolina Reaper',
    id: '2'
  }],
  internalProps: {
    fab: {
      icon: 'account',
      color: 'orca'
    },
    iconButton: {
      icon: 'account',
      color: 'orca'
    }
  }
};

// tslint:disable-next-line:no-object-literal-type-assertion

const _dataList = {
  children: jsxs(Fragment, {
    children: [jsx(ListItem, Object.assign({
      value: 1
    }, {
      children: "List Item 0"
    }), 1), jsx(ListItem, Object.assign({
      value: 2
    }, {
      children: "List Item 1"
    }), 2), jsx(ListItem, Object.assign({
      value: 3
    }, {
      children: "List Item 2"
    }), 3)]
  }, void 0),
  childrenString: `<>
  <ListItem value={1} key={1}>
    List Item 0
  </ListItem>
  <ListItem value={2} key={2}>
    List Item 1
  </ListItem>
  <ListItem value={3} key={3}>
    List Item 2
  </ListItem>
</>`,
  angularString: `<div slot="children">
    <xi-list-item [value]="0">
      <div slot="children">List Item 0</div>
    </xi-list-item>
    <xi-list-item [value]="1">
      <div slot="children">List Item 1</div>
    </xi-list-item>
    <xi-list-item [value]="2">
      <div slot="children">List Item 2</div>
    </xi-list-item>
  </div>
  `
}; // REQUIRED PROPS
// tslint:disable-next-line:no-object-literal-type-assertion

const _dataListItem = {
  children: jsx("div", {}, void 0),
  value: 0
};

const _dataImageCarousel = {
  images: new Array(10).fill(null).map(i => `https://picsum.photos/seed/seed${i * 100}/200/300`)
};
const _dataAudioPlayer = {
  source: 'https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-55112/zapsplat_nature_forest_birds_wind_trees_leaves_falling_qld_australia_56740.mp3?_=1'
};
const _dataVideoPlayer = {
  source: 'https://static.videezy.com/system/resources/previews/000/004/277/original/1.mp4'
};

const _dataGenericModal = {
  isVisible: false,
  children: jsx(Fragment, {
    children: jsx(BasicTile, Object.assign({
      color: "CX",
      padding: 100
    }, {
      children: jsx("h1", {
        children: "I'm a BasicTile inside of a Generic Modal!"
      }, void 0)
    }), void 0)
  }, void 0),
  childrenString: `<BasicTile color="CX" padding={100}>
  <h1>I'm a BasicTile inside of a Generic Modal!</h1>
</BasicTile>`,
  angularString: `<div slot="children">
    <xi-basic-tile color="CX" [padding]="100">
        <h1 slot="children">I'm a BasicTile inside of a Generic Modal!</h1>
    </xi-basic-tile>
  </div>`
};
const _dataPopout = {
  isVisible: true,
  'data-testid': 'popout'
};

const _dataLeftRightPicker = {
  title: 'string',
  data: {
    initialAvailableItems: [{
      id: '3',
      title: 'Baryonyx',
      disabled: true,
      tooltip: 'Baryonyx is not in user group.',
      searchTags: ['dinosaurs']
    }, {
      id: '4',
      title: 'Carnotaurus',
      disabled: false,
      searchTags: ['dinosaurs']
    }, {
      id: '5',
      title: 'Velocirapto',
      disabled: false,
      searchTags: ['dinosaurs']
    }, {
      id: '6',
      title: 'Giganotosaur Giganotosaur Giganotosaur Giganotosaur Giganotosaur',
      disabled: false,
      searchTags: ['dinosaurs']
    }, {
      id: '7',
      title: 'Ornithomimu',
      disabled: false,
      searchTags: ['volcanos']
    }, {
      id: '8',
      title: 'Tyrannosaur',
      disabled: false,
      searchTags: ['dinosaurs']
    }, {
      id: '9',
      title: 'Baryonyx',
      disabled: false,
      searchTags: ['dinosaurs']
    }, {
      id: '10',
      title: 'Popocatpetl',
      disabled: false,
      searchTags: ['dinosaurs']
    }, {
      id: '11',
      title: 'Pichincha Vol',
      disabled: false,
      searchTags: ['volcanos']
    }, {
      id: '12',
      title: 'Mount Katmai',
      disabled: false,
      searchTags: ['volcanos']
    }, {
      id: '13',
      title: 'Semeru',
      disabled: false,
      searchTags: ['volcanos']
    }, {
      id: '14',
      title: 'SoufriÃ¨re Hi',
      disabled: false,
      searchTags: ['volcanos']
    }, {
      id: '15',
      title: 'Mount Tambora',
      disabled: false,
      searchTags: ['volcanos']
    }, {
      id: '16',
      title: 'KÄlauea',
      disabled: false,
      searchTags: ['volcanos']
    }, {
      id: '17',
      title: 'Katla',
      disabled: false,
      searchTags: ['volcanos']
    }, {
      id: '18',
      title: 'Krakatoa',
      disabled: false,
      searchTags: ['volcanos']
    }, {
      id: '19',
      title: 'Mount Nyirago',
      disabled: false,
      searchTags: ['volcanos']
    }],
    initialSelectedItems: [{
      id: '2',
      title: 'Littlefoot',
      disabled: false,
      searchTags: ['dinosaurs']
    }]
  }
};
const _dataTreePicker = {
  categories: [{
    title: 'Category name that is really long and doesn’t fit on one line',
    options: [{
      id: 'Option 1',
      title: 'Option 1'
    }, {
      id: 'Option 2',
      title: 'Option 2'
    }, {
      id: 'Option 3',
      title: 'Option 3'
    }],
    subcategories: [{
      title: 'Subcategory 1',
      options: [{
        id: 'Option 4',
        title: 'Option 4'
      }, {
        id: 'Option 5',
        title: 'Option 5'
      }]
    }, {
      title: 'Subcategory 2',
      options: [{
        id: 'Option 5',
        title: 'Option 5'
      }, {
        id: 'Option 6',
        title: 'Option 6'
      }]
    }]
  }, {
    title: 'Category 2',
    options: [{
      id: 'Option 7',
      title: 'Option 7'
    }, {
      id: 'Option 8',
      title: 'Option 8'
    }, {
      id: 'Option 9',
      title: 'Option 9'
    }],
    subcategories: [{
      title: 'Subcategory 3',
      options: [{
        id: 'Option 10',
        title: 'Option 10'
      }, {
        id: 'Option 11',
        title: 'Option 11'
      }],
      subcategories: [{
        title: 'Subcategory 4',
        options: [{
          id: 'Option 5',
          title: 'Option 5'
        }, {
          id: 'Option 6',
          title: 'Option 6'
        }]
      }]
    }]
  }]
};
const _dataColorPicker = {
  selectedColor: {
    red: 64,
    green: 35,
    blue: 91,
    alpha: 1
  },
  direction: 7,
  inputType: 'RGB',
  hexContainsAlpha: false
};
const _dataHierarchyPicker = (() => {
  /** All of this data was adapted from {@link https://www.worldometers.info/} */
  const categories = [{
    title: 'World',
    options: [{
      title: 'Antarctica',
      id: 'Antarctica'
    }, {
      title: 'Australia',
      id: 'Australia'
    }],
    subcategories: [{
      // https://www.worldometers.info/geography/how-many-countries-in-africa/
      title: 'Africa',
      options: [],
      subcategories: [{
        title: 'East',
        options: [{
          title: 'Burundi',
          id: 'Burundi'
        }, {
          title: 'Comoros',
          id: 'Comoros'
        }, {
          title: 'Djibouti',
          id: 'Djibouti'
        }, {
          title: 'Eritrea',
          id: 'Eritrea'
        }, {
          title: 'Ethiopia',
          id: 'Ethiopia'
        }, {
          title: 'Kenya',
          id: 'Kenya'
        }, {
          title: 'Madagascar',
          id: 'Madagascar'
        }, {
          title: 'Malawi',
          id: 'Malawi'
        }, {
          title: 'Mauritius',
          id: 'Mauritius'
        }, {
          title: 'Mozambique',
          id: 'Mozambique'
        }, {
          title: 'Rwanda',
          id: 'Rwanda'
        }, {
          title: 'Seychelles',
          id: 'Seychelles'
        }, {
          title: 'Somalia',
          id: 'Somalia'
        }, {
          title: 'South Sudan',
          id: 'South Sudan'
        }, {
          title: 'Tanzania',
          id: 'Tanzania'
        }, {
          title: 'Uganda',
          id: 'Uganda'
        }, {
          title: 'Zambia',
          id: 'Zambia'
        }, {
          title: 'Zimbabwe',
          id: 'Zimbabwe'
        }]
      }, {
        title: 'Middle',
        options: [{
          title: 'Angola',
          id: 'Angola'
        }, {
          title: 'Cameroon',
          id: 'Cameroon'
        }, {
          title: 'Central African Republic',
          id: 'Central African Republic'
        }, {
          title: 'Chad',
          id: 'Chad'
        }, {
          title: 'Congo',
          id: 'Congo'
        }, {
          title: 'DR Congo',
          id: 'DR Congo'
        }, {
          title: 'Equatorial Guinea',
          id: 'Equatorial Guinea'
        }, {
          title: 'Gabon',
          id: 'Gabon'
        }, {
          title: 'Sao Tome & Principe',
          id: 'Sao Tome & Principe'
        }]
      }, {
        title: 'North',
        options: [{
          title: 'Algeria',
          id: 'Algeria'
        }, {
          title: 'Egypt',
          id: 'Egypt'
        }, {
          title: 'Libya',
          id: 'Libya'
        }, {
          title: 'Morocco',
          id: 'Morocco'
        }, {
          title: 'Sudan',
          id: 'Sudan'
        }, {
          title: 'Tunisia',
          id: 'Tunisia'
        }]
      }, {
        title: 'South',
        options: [{
          title: 'Botswana',
          id: 'Botswana'
        }, {
          title: 'Eswatini',
          id: 'Eswatini'
        }, {
          title: 'Lesotho',
          id: 'Lesotho'
        }, {
          title: 'Namibia',
          id: 'Namibia'
        }, {
          title: 'South Africa',
          id: 'South Africa'
        }]
      }, {
        title: 'West',
        options: [{
          title: 'Benin',
          id: 'Benin'
        }, {
          title: 'Burkina Faso',
          id: 'Burkina Faso'
        }, {
          title: 'Cabo Verde',
          id: 'Cabo Verde'
        }, {
          title: 'Gambia',
          id: 'Gambia'
        }, {
          title: 'Ghana',
          id: 'Ghana'
        }, {
          title: 'Guinea-Bissau',
          id: 'Guinea-Bissau'
        }, {
          title: 'Guinea',
          id: 'Guinea'
        }, {
          title: 'Liberia',
          id: 'Liberia'
        }, {
          title: 'Mali',
          id: 'Mali'
        }, {
          title: 'Mauritania',
          id: 'Mauritania'
        }, {
          title: 'Niger',
          id: 'Niger'
        }, {
          title: 'Nigeria',
          id: 'Nigeria'
        }, {
          title: 'Senegal',
          id: 'Senegal'
        }, {
          title: 'Sierra Leone',
          id: 'Sierra Leone'
        }, {
          title: 'Togo',
          id: 'Togo'
        }, {
          title: "Côte d'Ivoire",
          id: "Côte d'Ivoire"
        }]
      }, {
        title: 'Other',
        options: [{
          title: 'Mayotte',
          id: 'Mayotte'
        }, {
          title: 'Réunion',
          id: 'Réunion'
        }, {
          title: 'Saint Helena',
          id: 'Saint Helena'
        }, {
          title: 'Western Sahara',
          id: 'Western Sahara'
        }]
      }]
    }, {
      title: 'America',
      options: [],
      subcategories: [{
        // https://www.worldometers.info/geography/how-many-countries-in-latin-america/
        title: 'Carribean',
        options: [{
          title: 'Antigua and Barbuda',
          id: 'Antigua and Barbuda'
        }, {
          title: 'Bahamas',
          id: 'Bahamas'
        }, {
          title: 'Barbados',
          id: 'Barbados'
        }, {
          title: 'Cuba',
          id: 'Cuba'
        }, {
          title: 'Dominica',
          id: 'Dominica'
        }, {
          title: 'Dominican Republic',
          id: 'Dominican Republic'
        }, {
          title: 'Grenada',
          id: 'Grenada'
        }, {
          title: 'Haiti',
          id: 'Haiti'
        }, {
          title: 'Jamaica',
          id: 'Jamaica'
        }, {
          title: 'Saint Kitts & Nevis',
          id: 'Saint Kitts & Nevis'
        }, {
          title: 'Saint Lucia',
          id: 'Saint Lucia'
        }, {
          title: 'St. Vincent & Grenadines',
          id: 'St. Vincent & Grenadines'
        }, {
          title: 'Trinidad and Tobago',
          id: 'Trinidad and Tobago'
        }]
      }, {
        // https://www.worldometers.info/geography/how-many-countries-in-latin-america/
        title: 'Central',
        options: [{
          title: 'Belize',
          id: 'Belize'
        }, {
          title: 'Costa Rica',
          id: 'Costa Rica'
        }, {
          title: 'El Salvador',
          id: 'El Salvador'
        }, {
          title: 'Guatemala',
          id: 'Guatemala'
        }, {
          title: 'Honduras',
          id: 'Honduras'
        }, {
          title: 'Mexico',
          id: 'Mexico'
        }, {
          title: 'Nicaragua',
          id: 'Nicaragua'
        }, {
          title: 'Panama',
          id: 'Panama'
        }]
      }, {
        // https://www.worldometers.info/geography/how-many-countries-in-northern-america/
        title: 'North',
        options: [{
          title: 'Canada',
          id: 'Canada'
        }, {
          title: 'United States',
          id: 'United States'
        }]
      }, {
        // https://www.worldometers.info/geography/how-many-countries-in-latin-america/
        title: 'South',
        options: [{
          title: 'Argentina',
          id: 'Argentina'
        }, {
          title: 'Bolivia',
          id: 'Bolivia'
        }, {
          title: 'Brazil',
          id: 'Brazil'
        }, {
          title: 'Chile',
          id: 'Chile'
        }, {
          title: 'Colombia',
          id: 'Colombia'
        }, {
          title: 'Ecuador',
          id: 'Ecuador'
        }, {
          title: 'Guyana',
          id: 'Guyana'
        }, {
          title: 'Paraguay',
          id: 'Paraguay'
        }, {
          title: 'Peru',
          id: 'Peru'
        }, {
          title: 'Suriname',
          id: 'Suriname'
        }, {
          title: 'Uruguay',
          id: 'Uruguay'
        }, {
          title: 'Venezuela',
          id: 'Venezuela'
        }]
      }]
    }, {
      // https://www.worldometers.info/geography/how-many-countries-in-asia/
      title: 'Asia',
      options: [],
      subcategories: [{
        title: 'Central',
        options: [{
          title: 'Kazakhstan',
          id: 'Kazakhstan'
        }, {
          title: 'Kyrgyzstan',
          id: 'Kyrgyzstan'
        }, {
          title: 'Tajikistan',
          id: 'Tajikistan'
        }, {
          title: 'Turkmenistan',
          id: 'Turkmenistan'
        }, {
          title: 'Uzbekistan',
          id: 'Uzbekistan'
        }]
      }, {
        title: 'East',
        options: [{
          title: 'China',
          id: 'China'
        }, {
          title: 'Japan',
          id: 'Japan'
        }, {
          title: 'Mongolia',
          id: 'Mongolia'
        }, {
          title: 'North Korea',
          id: 'North Korea'
        }, {
          title: 'South Korea',
          id: 'South Korea'
        }]
      }, {
        title: 'South',
        options: [{
          title: 'Afghanistan',
          id: 'Afghanistan'
        }, {
          title: 'Bangladesh',
          id: 'Bangladesh'
        }, {
          title: 'Bhutan',
          id: 'Bhutan'
        }, {
          title: 'India',
          id: 'India'
        }, {
          title: 'Iran',
          id: 'Iran'
        }, {
          title: 'Maldives',
          id: 'Maldives'
        }, {
          title: 'Nepal',
          id: 'Nepal'
        }, {
          title: 'Pakistan',
          id: 'Pakistan'
        }, {
          title: 'Sri Lanka',
          id: 'Sri Lanka'
        }]
      }, {
        title: 'South-East',
        options: [{
          title: 'Brunei ',
          id: 'Brunei'
        }, {
          title: 'Cambodia',
          id: 'Cambodia'
        }, {
          title: 'Indonesia',
          id: 'Indonesia'
        }, {
          title: 'Laos',
          id: 'Laos'
        }, {
          title: 'Malaysia',
          id: 'Malaysia'
        }, {
          title: 'Myanmar',
          id: 'Myanmar'
        }, {
          title: 'Philippines',
          id: 'Philippines'
        }, {
          title: 'Singapore',
          id: 'Singapore'
        }, {
          title: 'Thailand',
          id: 'Thailand'
        }, {
          title: 'Timor-Leste',
          id: 'Timor-Leste'
        }, {
          title: 'Vietnam',
          id: 'Vietnam'
        }]
      }, {
        title: 'West',
        options: [{
          title: 'Armenia',
          id: 'Armenia'
        }, {
          title: 'Azerbaijan',
          id: 'Azerbaijan'
        }, {
          title: 'Bahrain',
          id: 'Bahrain'
        }, {
          title: 'Cyprus',
          id: 'Cyprus'
        }, {
          title: 'Georgia',
          id: 'Georgia'
        }, {
          title: 'Iraq',
          id: 'Iraq'
        }, {
          title: 'Israel',
          id: 'Israel'
        }, {
          title: 'Jordan',
          id: 'Jordan'
        }, {
          title: 'Kuwait',
          id: 'Kuwait'
        }, {
          title: 'Lebanon',
          id: 'Lebanon'
        }, {
          title: 'Oman',
          id: 'Oman'
        }, {
          title: 'Qatar',
          id: 'Qatar'
        }, {
          title: 'Saudi Arabia',
          id: 'Saudi Arabia'
        }, {
          title: 'State of Palestine',
          id: 'State of Palestine'
        }, {
          title: 'Syria',
          id: 'Syria'
        }, {
          title: 'Turkey',
          id: 'Turkey'
        }, {
          title: 'United Arab Emirates',
          id: 'United Arab Emirates'
        }, {
          title: 'Yemen',
          id: 'Yemen'
        }]
      }, {
        title: 'Other',
        options: [{
          title: 'Hong Kong',
          id: 'Hong Kong'
        }, {
          title: 'Macao',
          id: 'Macao'
        }, {
          title: 'Taiwan',
          id: 'Taiwan'
        }]
      }]
    }, {
      // https://www.worldometers.info/geography/how-many-countries-in-europe/
      title: 'Europe',
      options: [],
      subcategories: [{
        title: 'East',
        options: [{
          title: 'Belarus',
          id: 'Belarus'
        }, {
          title: 'Bulgaria',
          id: 'Bulgaria'
        }, {
          title: 'Czech Republic (Czechia)',
          id: 'Czech Republic (Czechia)'
        }, {
          title: 'Hungary',
          id: 'Hungary'
        }, {
          title: 'Moldova',
          id: 'Moldova'
        }, {
          title: 'Poland',
          id: 'Poland'
        }, {
          title: 'Romania',
          id: 'Romania'
        }, {
          title: 'Russia',
          id: 'Russia'
        }, {
          title: 'Slovakia',
          id: 'Slovakia'
        }, {
          title: 'Ukraine',
          id: 'Ukraine'
        }]
      }, {
        title: 'North',
        options: [{
          title: 'Denmark',
          id: 'Denmark'
        }, {
          title: 'Estonia',
          id: 'Estonia'
        }, {
          title: 'Finland',
          id: 'Finland'
        }, {
          title: 'Iceland',
          id: 'Iceland'
        }, {
          title: 'Ireland',
          id: 'Ireland'
        }, {
          title: 'Latvia',
          id: 'Latvia'
        }, {
          title: 'Lithuania',
          id: 'Lithuania'
        }, {
          title: 'Norway',
          id: 'Norway'
        }, {
          title: 'Sweden',
          id: 'Sweden'
        }, {
          title: 'United Kingdom',
          id: 'United Kingdom'
        }]
      }, {
        title: 'Other',
        options: [{
          title: 'Faeroe Islands',
          id: 'Faeroe Islands'
        }, {
          title: 'Gibraltar',
          id: 'Gibraltar'
        }, {
          title: 'Isle of Man',
          id: 'Isle of Man'
        }]
      }, {
        title: 'West',
        options: [{
          title: 'Austria',
          id: 'Austria'
        }, {
          title: 'Belgium',
          id: 'Belgium'
        }, {
          title: 'France',
          id: 'France'
        }, {
          title: 'Germany',
          id: 'Germany'
        }, {
          title: 'Liechtenstein',
          id: 'Liechtenstein'
        }, {
          title: 'Luxembourg',
          id: 'Luxembourg'
        }, {
          title: 'Monaco',
          id: 'Monaco'
        }, {
          title: 'Netherlands',
          id: 'Netherlands'
        }, {
          title: 'Switzerland',
          id: 'Switzerland'
        }]
      }]
    }]
  }];
  return {
    categories,
    filterProps: {
      data: [{
        title: 'World',
        id: 'World'
      }, {
        title: 'Africa',
        id: 'Africa'
      }, {
        title: 'America',
        id: 'America'
      }, {
        title: 'Asia',
        id: 'Asia'
      }, {
        title: 'Europe',
        id: 'Europe'
      }]
    }
  };
})();

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataCloudPill = {
  cloud: 'CUSTOMER'
};
const _dataCustomPill = {
  text: '1X'
};

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataRadio = {
  value: 'string'
};

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataSearchBox = {};

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataSlider = {};

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataToggleSwitch = {
  isToggled: false
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataToggleText = {
  leftText: 'string',
  rightText: 'string'
};

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataVerticalTabBar = {
  data: [{
    icon: 'ab_testing',
    id: 'tab0',
    hint: 'Summary',
    disabled: true,
    disabledReason: 'too cool for school'
  }, {
    icon: 'action_planning_filled',
    id: 'tab1',
    hint: 'Summary 1',
    hasSeparator: true
  }, {
    icon: 'app_home',
    hasSeparator: false
  }]
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataTabBar = {
  data: [{
    alert: false,
    id: 'tab0',
    title: 'Summary'
  }, {
    alert: false,
    id: 'tab1',
    title: 'Summary 1'
  }, {
    alert: false,
    id: 'tab2',
    title: 'Summary 2'
  }, {
    alert: false,
    id: 'tab3',
    title: 'Summary 3'
  }, {
    alert: false,
    id: 'tab4',
    title: 'SummaryLong 4'
  }, {
    alert: false,
    id: 'tab5',
    title: 'SummaryLong 5'
  }, {
    alert: false,
    id: 'tab6',
    title: 'SummaryLong 6'
  }, {
    alert: false,
    id: 'tab7',
    title: 'Sum 7'
  }]
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataHorizontalTabBar = {
  data: [{
    alert: false,
    id: 'tab0',
    title: 'Summary'
  }, {
    alert: false,
    id: 'tab1',
    title: 'Summary 1'
  }, {
    alert: false,
    id: 'tab2',
    title: 'Summary 2'
  }, {
    alert: false,
    id: 'tab3',
    title: 'Summary 3'
  }, {
    alert: false,
    id: 'tab4',
    title: 'SummaryLong 4'
  }, {
    alert: false,
    id: 'tab5',
    title: 'SummaryLong 5'
  }, {
    alert: false,
    id: 'tab6',
    title: 'SummaryLong 6'
  }, {
    alert: false,
    id: 'tab7',
    title: 'Sum 7'
  }]
};

const _dataTable = {
  headers: [{
    id: '1',
    title: 'NPS',
    field: 'nps'
  }, {
    id: '2',
    title: 'Comment',
    field: 'comment'
  }],
  headerData: [{
    id: '1',
    title: 'Username',
    field: 'username',
    bgColor: XIColors.admin.primary,
    textColor: XIColors.white.primary
  }, {
    id: '2',
    title: 'Email',
    field: 'email',
    bgColor: XIColors.blue.primary,
    textColor: XIColors.white.primary
  }, {
    id: '3',
    title: 'Last Login',
    field: 'lastLogin',
    bgColor: XIColors.orca.primary,
    textColor: XIColors.white.primary
  }],
  rowData: [{
    id: '1-a',
    username: 'nicholek',
    email: 'nichole@blank.com',
    lastLogin: '11/04/2021'
  }, {
    id: '1-b',
    username: 'trevorh',
    email: 'trevor@lel.com',
    lastLogin: '12/04/2021'
  }, {
    id: '1-c',
    username: 'tommyw',
    email: 'tommy@birthday.com',
    lastLogin: '05/04/2021'
  }],
  row_set_2: [{
    id: '1-a',
    nps: 5.0,
    comment: 'It was dandy'
  }, {
    id: '1-b',
    nps: -20,
    comment: 'Very much less than dandy...'
  }, {
    id: '1-c',
    nps: 1,
    comment: 'Solid neutral dandy'
  }]
};

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataEditableText = {
  contrast: 'normal'
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataInputField = {
  placeholder: 'InputField'
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataTextArea = {
  placeholder: 'TextArea'
};

const _dataBasicTile = {
  padding: 100,
  children: jsxs(Fragment, {
    children: [jsx(XIIcon, {
      icon: "brand_survey"
    }, void 0), jsx("p", {
      children: "I am some children inside a BasicTile"
    }, void 0)]
  }, void 0),
  childrenString: `<XIIcon icon="brand_survey" />
  <p>I am some children inside a BasicTile</p>`,
  angularString: `<div slot="children">
    <xi-icon icon="brand_survey"></xi-icon>
    <p>I am some children inside a BasicTile</p>
  </div>`
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataWaveTile = {
  title: 'Title',
  subtitle: 'Subtitle',
  icon: 'brand_survey'
};

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataToolTipContent = {
  tooltip: {
    text: 'Text'
  }
};

const _dataAppTitleBar = {
  text: 'Title',
  children: jsx(HorizontalTabBar, {
    hasTransparentBackground: true,
    contrast: "high",
    data: _dataTabBar.data
  }, void 0),
  childrenString: `<>
  <TabBar hasTransparentBackground contrast="high" style={{ width: '100%' }} data={_dataTabBar.data} />
</>`,
  angularString: `<div slot="children">
    <xi-tab-bar [hasTransparentBackground]="true" contrast="high" [data]="_dataTabBar.data" />
  </div>`
};

// tslint:disable-next-line:no-object-literal-type-assertion
const _dataXIAnimation = {
  animation: 'admin_loader'
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataXIAppIcon = {
  icon: 'admin'
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataXIIcon = {
  icon: 'account'
}; // tslint:disable-next-line:no-object-literal-type-assertion

const _dataXISVG = {
  svg: 'display_ab_running'
};

export { _dataAccordion, _dataAlertInlineMain, _dataAppSideDisplay, _dataAppTitleBar, _dataAudioPlayer, _dataBasicTile, _dataBigNumber, _dataChartWrapper, _dataCheckbox, _dataCloudPill, _dataColorPicker, _dataComment, _dataCondensedExperienceCard, _dataCustomPill, _dataDefaultButton, _dataDrawer, _dataDropdown, _dataEditableText, _dataExperienceCard, _dataExperienceCardCommentArray, _dataExperienceCardImageCarousel, _dataExperienceCardNotes, _dataExperienceCardTags, _dataFAB, _dataFilterButton, _dataGenericModal, _dataHeadingButton, _dataHierarchyPicker, _dataHorizontalTabBar, _dataIconButton, _dataImageCarousel, _dataInputField, _dataLeftRightPicker, _dataList, _dataListItem, _dataPopout, _dataRadio, _dataSearchBox, _dataSentimentButton, _dataSidePanel, _dataSlider, _dataSnackBar, _dataSuccessToaster, _dataTabBar, _dataTable, _dataTextArea, _dataToggleSwitch, _dataToggleText, _dataToolTipContent, _dataTreePicker, _dataVerticalTabBar, _dataVideoPlayer, _dataWarningPopup, _dataWaveTile, _dataXIAnimation, _dataXIAppIcon, _dataXIIcon, _dataXISVG };
